import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HorseService } from '../../../providers/horse.service';
import { AddHorseViewService } from '../providers/add-horse-view.service';
import { Horse } from '../../../models/horse';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { ModalConfirmDialogComponent } from '../../modal-confirm-dialog/modal-confirm-dialog.component';
import { faPlus, faTrash, faEye, faEdit }  from '@fortawesome/fontawesome-pro-regular';
import { faHorse, faToolbox, faCaretSquareRight, faLink, faUnlink } from '@fortawesome/pro-solid-svg-icons'

@Component({
  standalone: false,
  selector: 'app-my-horses',
  templateUrl: './my-horses.component.html',
styleUrls:  ['./my-horses.component.css']
})

export class MyHorsesComponent extends SmsAbstractAppPage implements OnInit {
	show_more_horse: boolean[] = [];
	show_edit_horse: boolean[] = [];
	faPlus = faPlus;
	faHorse = faHorse;
	faTrash = faTrash;
	faEye = faEye;
	faEdit = faEdit;
  faToolbox = faToolbox;
  faLink = faLink;
  faUnlink = faUnlink;
  faCaretSquareRight = faCaretSquareRight;
	horse_list: Horse[] = [];

  /*download list of all vaccines by querying on user id then store in list
    *iterate list and flag horses with vaccine list. Display in modal dialog*/

  constructor(private modal: NgbModal, private horseService: HorseService, private addHorseViewService: AddHorseViewService) {
  	super();
  }

  ngOnInit() {
  	this.horseService.getList().then(horses => {
  		this.horse_list = horses;

  		this.initBooleanViewFlags();

  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  handleAddHorse(){
    const addToList = (horse: Horse) => {
      this.horse_list.push(horse);
      this.horse_list.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
      this.initBooleanViewFlags();
    };

    this.addHorseViewService.doAddHorse().then(new_horse => {
      if (new_horse.id) {
        addToList(new_horse);
      } else {
        this.horseService.create(new_horse).then(addToList).catch(error => {
          this.handleError(error);
        });
      }
    }).catch(error => {
      this.handleError(error);
    });
  }

  handleHideHorse(horse: Horse){
  	let modal_ref_confirm = this.modal.open(ModalConfirmDialogComponent, {size: 'sm'});
     modal_ref_confirm.componentInstance.title = 'HIDE ' + horse.name + "!";

     let str_message: string =  "Please confirm that you want to remove " + horse.name + " " + horse.name + " from your list of horses.";

     str_message += "If you remove "+ horse.name + " " + horse.name + " from your account, they will still appear on any entries you've previously created but they will no longer appear as a choice in your list.";

     modal_ref_confirm.componentInstance.message = str_message;


     modal_ref_confirm.componentInstance.yes$.subscribe(response => {
       if(response){
         modal_ref_confirm.close();
         this.horseService.hide(horse).then(response => {
           if(response){
             this.horse_list.forEach((l_horse, i) => {
               if(l_horse.id == horse.id){
                 this.horse_list.splice(i, 1);
               }
             });
           }
         }).catch(error => {
           this.handleError(error);
         });
       }
     }, error => {
       this.handleError(error);
       modal_ref_confirm.close();
     });

  }

  onSaveHorse(horse: Horse, index: number){

  	this.horseService.update(horse).then(updated_horse => {
  		this.horse_list[index] = updated_horse;
  		this.show_more_horse[index] = false;
  		this.show_edit_horse[index] = false;
  	}).catch(error => {
  		this.handleError(error);
  	});

  }

  initBooleanViewFlags(){
  //init boolean arrays to show/hide view more and edit
  	this.show_more_horse = [];
  	this.show_edit_horse = [];

	this.horse_list.forEach((horse, i) => {
		this.show_more_horse.push(false);
		this.show_edit_horse.push(false);
	});
  }

}
